import * as _ from 'lodash';
import { MissingSideMembersState} from "./state";
import { MissingSideMembersActions, MissingSideMembersAction} from './action';

const initialState = require('./initial-data.json') as MissingSideMembersState;
export function MissingSideMembersReducer(
    state: MissingSideMembersState = initialState, 
    action: MissingSideMembersAction
): MissingSideMembersState {
    switch (action.type)
    {
            case MissingSideMembersActions.LoadMissingSideMembersPageAction:
                return {
                    ...state,
                    missingSideMembers: action.payload
                };                        
            case MissingSideMembersActions.ChangeMissingSideMembersFilterExpressionAction:
                return {
                    ...state,
                    missingSideMembers: null,
                    missingSideMembersTotalCount: 0,
                    missingSideMembersPaging: { ...state.missingSideMembersPaging, page: 1 },
                    missingSideMembersFilterExpression: action.payload
                };
            case MissingSideMembersActions.ChangeMissingSideMembersSortExpressionAction:
                return {
                    ...state,
                    missingSideMembers: null,
                    missingSideMembersTotalCount: 0,
                    missingSideMembersPaging: { ...state.missingSideMembersPaging, page: 1 },
                    missingSideMembersSortExpression: action.payload
                };
            case MissingSideMembersActions.ChangeMissingSideMembersPageAction:
                return {
                    ...state,
                    missingSideMembers: null,
                    missingSideMembersTotalCount: 0,
                    missingSideMembersPaging: { ...state.missingSideMembersPaging, page: action.payload },
                };
            case MissingSideMembersActions.ChangeMissingSideMembersTotalCountAction:
                return {
                    ...state,
                    missingSideMembersTotalCount: action.payload.totalCount
                };            
            default:
                return state;
        }
    }
    